import { Button, EditUserPerms } from "@factorearth/component-library";
import { generateClient, GraphQLResult } from "aws-amplify/api";
import { Role, RoleForResolver, User } from "db/definitions";
import { fetchRoles as fetchAllRoles } from "db/queries/roleQueries";
import { getUser } from "graphql/queries";
import { useTheme } from "hooks/useSingleton";
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { useParams, useNavigate } from "react-router";
import { getRoles } from "utils/getRoles";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

interface EditPermissionProps {
	online: boolean;
}

export const EditPermission = (props: EditPermissionProps) => {
	const { id } = useParams<{ id: string }>();
	const [user, setUser] = useState<User>();
	const [roles, setRoles] = useState<Role[] | RoleForResolver[]>([]);
	const colorPalette = useTheme();
	const navigate = useNavigate();

	useEffect(() => {
		const fetchUser = async () => {
			try {
				let retrieved = (await generateClient({ authMode: "userPool" }).graphql({
					query: getUser,
					variables: {
						id: id!,
					},
					authMode: "userPool",
				})) as unknown as GraphQLResult<{ getUser: User }>;
				setUser(retrieved.data.getUser);
			} catch (error) {
				console.log(error);
			}
		};
		fetchUser();
		const fetchRoles = async () => {
			if (props.online) {
				const response = await getRoles();
				setRoles(response);
			} else {
				const response = await fetchAllRoles();
				setRoles(response);
			}
		};
		fetchRoles();
	}, []);
	return user && roles ? (
		<div style={{ margin: "24px", gap: "24px", display: "flex", flexDirection: "column" }}>
			<div>
				<Button variant="outlined" label="Back" onClick={() => navigate(-1)} colorPalette={colorPalette} icon={<FiChevronLeft />} />
			</div>
			<EditUserPerms theme={colorPalette} user={user as any} roles={roles as any} handleChange={async (role) => {}} />;
		</div>
	) : (
		<LoadingSpinner />
	);
};
